<template>
  <div :class="rootClass[name]">
    <h2 class="title">{{ parseName }}</h2>
    <draggable v-model="getFocuses" group="list" @end="onEnd" @start="onStart">
      <transition-group name="list" tag="div" class="card-section" :id="name">
        <div
          class="card-j card-tracked"
          v-for="(card, index) in getFocuses"
          :key="index + 1"
          :id="card.focusId"
        >
          <div v-if="!statusLoading">
            <focus-card
              v-if="card !== undefined"
              :card="card"
              :allTools="allTools"
            ></focus-card>
          </div>
        </div>
      </transition-group>
    </draggable>

    <focus-active
      v-if="itemToMove"
      :modalTrack="modalTrack"
      :modalStationed="modalStationed"
      :isUsersOnDb="isUsersOnDb"
      :isTryToConnect="isTryToConnect"
      :virtualStateParent="virtualState"
      :activateEmailListParent="activateEmailList"
      :itemToMoveDetail="itemToMoveDetail"
      :itemToMoveParent="itemToMove"
      :itemToMoveId="itemToMoveId"
      @modal:reason-stationed-close="modalStationed = false"
      @modal:reason-track-close="modalTrack = false"
      v-bind:activateEmailList.sync="activateEmailList"
      v-bind:virtualState.sync="virtualState"
      v-bind:itemToMove.sync="itemToMove"
    />
  </div>
</template>
<script>
import draggable from "vuedraggable";
import focusActive from "./focusActive";
import focusCard from "./focusCard";

import { mapGetters } from "vuex";
export default {
  props: ["name"],
  components: {
    draggable,
    focusCard,
    focusActive
  },

  data() {
    return {
      statusLoading: false,
      modalStationed: false,
      modalTrack: false,
      itemToMoveId: null,
      itemToMove: null,
      itemToMoveDetail: null,
      activateEmailList: [],
      isUsersOnDb: [],
      isTryToConnect: [],
      virtualState: [],
      rootClass: {
        ontrack: "tracked tracked-set",
        stationed: "stationed",
        ondeck: "deck"
      },
      allTools: []
    };
  },
  mounted() {
    this.$store.dispatch("user/getListTools").then(res => {
      this.allTools = res;
    });
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      focuses: "user/focuses",
      profile: "user/profile"
    }),
    titleFocus: {
      get() {
        return this.itemToMove
          ? this.itemToMove.item.innerText.slice(
              0,
              this.itemToMove.item.innerText.indexOf(" so that ")
            )
          : null;
      }
    },
    parseName() {
      return this.name === "ondeck"
        ? "on deck"
        : this.name === "ontrack"
        ? "on track"
        : "stationed";
    },
    getFocuses: {
      get() {
        return this.sortFocuses(
          this.focuses.filter(fj => fj.state === this.name)
        );
      },
      set(value) {
        this.$store.commit("user/UPDATED_FOCUS_POSITION", {
          items: value,
          from: this.name
        });
      }
    }
  },
  methods: {
    onUpdatedItemMove(val) {
      this.itemToMove = val;
    },
    onStart(e) {
      this.itemToMoveDetail = this.getFocuses.filter(el => {
        return el.focusId === e.item.id;
      })[0];
    },
    async onEnd(e) {
      let evt = { ...e };
      // this.updatedPositionFocus();
      if (evt.to.id === "stationed") {
        this.itemToMove = { item: evt.item, from: evt.from, to: evt.to };
        this.itemToMoveId = evt.item.id;
        this.modalStationed = true;
      } else if (evt.to.id === "ontrack") {
        this.itemToMove = { item: evt.item, from: evt.from, to: evt.to };
        this.itemToMoveId = evt.item.id;
        this.modalTrack = true;
        if (
          this.itemToMoveDetail &&
          this.itemToMoveDetail.crew &&
          this.itemToMoveDetail.crew
            .filter(el => !el._connected_at)
            .filter(el => !el._deleted_at).length
        ) {
          this.itemToMove = { item: evt.item, from: evt.from, to: evt.to };
          this.isModalMoveToOnTrack = true;
          if (this.itemToMoveDetail && this.itemToMoveDetail._activated_at) {
            this.virtualState = this.itemToMoveDetail.crew
              .filter((el, i) => !el._connected_at)
              .map(el => "standard");
            this.activateEmailList = this.itemToMoveDetail.crew
              .filter((el, i) => !el._connected_at)
              .map(el => "");
            this.isUsersOnDb = this.itemToMoveDetail.crew
              .filter((el, i) => !el._connected_at)
              .map(el => ({}));
            this.isTryToConnect = this.itemToMoveDetail.crew
              .filter((el, i) => !el._connected_at)
              .map(el => false);
          } else {
            this.virtualState = this.itemToMoveDetail.crew.map(
              el => "standard"
            );
            this.activateEmailList = this.itemToMoveDetail.crew.map(el => "");
            this.isUsersOnDb = this.itemToMoveDetail.crew.map(el => ({}));
            this.isTryToConnect = this.itemToMoveDetail.crew.map(el => false);
          }
        }
        //   else {
        //     this.saveEventInList();
        //     this.$store.dispatch("user/updateFocuses", {
        //       focusId: e.item.id,
        //       state: e.to.id
        //     });
        //   }
        return;
      } else {
        // this.updatedPositionFocus();
        this.$store.dispatch("user/updateFocuses", {
          focusId: e.item.id,
          state: e.to.id
        });
      }
    },
    saveEventInList() {
      if (!this.itemToMoveDetail._duration) {
        this.$store.dispatch("user/updateFocuses", {
          _duration: "6 Weeks",
          focusId: this.itemToMoveId
        });
      }
      this.$store.dispatch("user/saveEventInLists", {
        focus: this.itemToMoveDetail,
        focusId: this.itemToMoveId
      });
    },
    async updatedPositionFocus() {
      this.$nprogress.start();
      this.statusLoading = true;

      await this.$store.dispatch("user/updateFocusPosition");

      this.statusLoading = false;
      this.$nprogress.done();
    },
    sortFocuses(items) {
      let sortArray = [];
      items.forEach((element, index) => {
        if (element.position === undefined) {
          sortArray[index] = element;
        } else {
          sortArray[element.position] = element;
        }
      });

      return sortArray.filter(val => val !== "");
    }
  }
};
</script>
